module.exports = __webpack_public_path__ + "media/images/steps/svg/197-meeting-2-46d709dcfd8145f291d2880466947841.svg";